/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, position: NonNullable<unknown>, total: NonNullable<unknown> }} Settings_Templates_Drag_EndInputs */



/**
* | output |
* | --- |
* | "{name} dropped in position {position} of {total}." |
*
* @param {Settings_Templates_Drag_EndInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_drag_end = /** @type {((inputs: Settings_Templates_Drag_EndInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_Drag_EndInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} neergezet op plaats ${i?.position} van ${i?.total}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} déposé en position ${i?.position} sur ${i?.total}.`)
	return /** @type {LocalizedString} */ (`${i?.name} dropped in position ${i?.position} of ${i?.total}.`)
});